define(["exports", "react", "react-intl-universal", "styled-components", "../../atoms/Typography"], function (_exports, _react, _reactIntlUniversal, _styledComponents, _Typography) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _reactIntlUniversal = _interopRequireDefault(_reactIntlUniversal);
  _styledComponents = _interopRequireDefault(_styledComponents);

  var TextComplementary = _styledComponents.default.div.withConfig({
    displayName: "Complementary__TextComplementary",
    componentId: "sc-12kx4d2-0"
  })(["h2{margin:0 0 16px;}p{margin:0;}"]);

  var Complementary = function Complementary(_ref) {
    var infos = _ref.infos;
    return /*#__PURE__*/_react.default.createElement(TextComplementary, null, /*#__PURE__*/_react.default.createElement(_Typography.H2, null, _reactIntlUniversal.default.get('CURRICULUM.COMPLEMENTARES.TITULO')), /*#__PURE__*/_react.default.createElement(_Typography.Small, null, infos));
  };

  Complementary.defaultProps = {
    infos: ''
  };
  var _default = Complementary;
  _exports.default = _default;
});